module.exports = __webpack_public_path__ + "static/media/House_ATL_Pipeline_Dummy_Data.139321a8.csv";